(() => {
  const isCpbParent = (item) => item && item.product_type === 'cpb_hybrid';

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function removeByKey(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  let running = false;

  async function cleanup() {
    if (running) return;
    running = true;

    try {
      const cart = await getCart();
      const parents = (cart.items || []).filter(isCpbParent);
      if (!parents.length) return;

      for (const p of parents) await removeByKey(p.key);

      // Cart Page fallback refresh (Drawer aktualisiert meist via AJAX)
      if (document.body.classList.contains('template-cart')) {
        location.reload();
      }
    } catch (e) {
      console.error('[CPB parent cleanup] failed', e);
    } finally {
      running = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => cleanup());

  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-item-remove],[data-quantity-plus],[data-quantity-minus],a[href*="/cart/change"]');
    if (!el) return;
    setTimeout(cleanup, 400);
  });

  // Hook in fetch() to catch AJAX cart operations (drawer, CPB, etc.)
  const origFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await origFetch.apply(this, args);

    try {
      const url = (args[0] && args[0].url) ? args[0].url : String(args[0] || '');
      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        setTimeout(cleanup, 200);
      }
    } catch (_) {}

    return res;
  };
})();